import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import api from '../../services/api';
import {
  TextField,
  FormGroup,
  Grid,
  Card,
  CardContent,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import * as Yup from 'yup';
import NumberFormat from 'react-number-format';
import Progress from '../../components/Progress';
import { useDispatch, useSelector } from 'react-redux';

import { setDisable } from '../../redux/disable';
import { setLoading } from '../../redux/loading';
import { useStyles } from '../../components/Styles';
import Success from '../../components/Snack/Success';
import Error from '../../components/Snack/Error';
import GroupButton from '../../components/Buttons/ButtonGroup';
import styleGlobal from '../../Global.module.css';
import InfoIcon from '@mui/icons-material/Info';
import HelpIcon from '@mui/icons-material/Help';
import RemittanceService from 'services/RemittanceService';

function Lot() {
  const location = useLocation();
  const time = new Date();
  const outraData = new Date();
  outraData.setDate(time.getDate() + 120); // Adiciona 120 dias
  const [openProgress, setOpenProgress] = useState(false);
  const [species, setSpecies] = useState([]);
  const classes = useStyles();
  const [user, setUser] = useState(null);
  const dispatch = useDispatch();
  const history = useHistory();
  let { id } = useParams();
  const disable = useSelector((state) => state.disable.disable);
  const error = Error();
  const success = Success();

  useEffect(() => {
    if (location.state !== undefined) {
      if (location.state.customData) {
        setData(location.state.customData);
        formik.setFieldValue('id', null);
      } else if (location.state.data) {
        id = location.state.id;
        setData(location.state.data);
      }
    }
  }, [location]);

  function setData(data) {
    formik.setValues({ ...data, specie: data.specie.id });
  }

  useEffect(() => {
    // carrega os dados no seu devido campo caso tenha id, do contrário,
    // carrega o formulário vazio para cadastrar um novo
    async function load() {
      setOpenProgress(true);
      const userId = await api.get('/properties');
      if (userId.data) {
        setUser(userId.data.user_id);
        formik.values.user_id = userId.data.user_id;
      }

      setOpenProgress(false);
    }
    load();
  }, []);

  useEffect(() => {
    async function loadSpecies() {
      try {
        setOpenProgress(true);
        const response = await RemittanceService.speciesList();
        setSpecies(response);
      } catch (e) {
        error('Erro ao buscar dados sobre as espécies');
      } finally {
        setOpenProgress(false);
      }
    }
    loadSpecies();
  }, []);

  async function request(data) {
    // envia os dados para api salvar no banco

    try {
      id
        ? await api.put(`/lots/${id}`, { ...data })
        : await api.post('/lots', { ...data });
      success();
      history.push('/lots');
    } catch (err) {
      error();
    }
    dispatch(setDisable(false));
    dispatch(setLoading(false));
  }

  // Criação dos campos e validação para o formulário
  const formik = useFormik({
    initialValues: {
      old: '',
      specie: '',
      size: '',
      provider_id: '',
      user_id: user,
      name: '',
      price: '',
      size_remain: '',
    },
    validationSchema: Yup.object({
      old: Yup.number()
        .required('Campo Obrigatório')
        .moreThan(0, 'Precisa ser acima de 0')
        .max(2, 'Máximo de caracteres ultrapassado (3 caracteres)'),
      specie: Yup.string().required('Campo Obrigatório'),
      name: Yup.string().max(
        99,
        'Máximo de caracteres ultrapassado (100 caracteres).',
      ).required('Campo Obrigatório'),
      size: Yup.number()
        .required('Campo Obrigatório')
        .moreThan(0, 'Precisa ser acima de 0')
        .max(10, 'Máximo de caracteres ultrapassado (11 caracteres)'),
      price: Yup.number()
        .required('Campo Obrigatório')
        .moreThan(0, 'Precisa ser acima de 0')
        .max(99999999999999, 'Máximo de caracteres ultrapassado (14 caracteres)'),
    }),
    onSubmit: (values) => {
      dispatch(setDisable(true));
      if (!id) {
        formik.values.size_remain = formik.values.size;
      }
      if (id) request(values);
      else CodeCheck(values);
    },
  });

  async function CodeCheck(values) {
    const lots = await api.get('/lots/');
    const codes = lots.data.map((e) => e.name);

    if (codes.includes(values.name) === true) {
      alert('Nome precisa ser único');
    } else {
      dispatch(setLoading(true));
      request(values);
    }
  }

  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#FFFFFF',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 300,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #0367bf',
    },
  }))(Tooltip);

  return (
    <header className={styleGlobal.headerGlobal}>
      {openProgress ? <Progress /> : null}
      {' '}
      <Card style={{ padding: '2rem', borderRadius: '20px' }}>
        {/** Carregamento circular para o carregamento dos dados */}
        <form onSubmit={formik.handleSubmit}>
          <div className={classes.root}>
            <h2 style={{ marginBottom: '2rem' }}>
              Dados da Remessa
              {' '}
              <HtmlTooltip
                title={(
                  <>
                    Nessa tela é possível registrar um lote de animais adquiridos. Esse lote será usado para registrar os povoamentos.
                  </>
                )}
                placement="right"
                arrow
                interactive
              >
                <InfoIcon color="primary" fontSize="inherit" />
              </HtmlTooltip>
            </h2>
            <CardContent style={{ padding: '0rem' }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={2}>
                  <FormGroup>
                    <TextField
                      inputProps={{ maxLength: 100 }}
                      InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                      id="name"
                      label="Nome"
                      variant="outlined"
                      name="name"
                      type="text"
                      value={formik.values.name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={!!(formik.touched.name && formik.errors.name)}
                      helperText={
                        formik.touched.name
                        && formik.errors.name
                        && formik.errors.name
                      }
                    />
                  </FormGroup>
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    value={formik.values.specie}
                    InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                    select
                    label="Espécie"
                    onChange={(e) => {
                      formik.setFieldValue('specie', e.target.value);
                    }}
                    onBlur={() => formik.setFieldTouched('specie', true)}
                    variant="outlined"
                    error={formik.touched.specie && formik.errors.specie}
                    helperText={formik.touched.specie && formik.errors.specie}
                  >
                    {species?.map((item) => (
                      <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={12} md={2}>
                  <FormGroup>
                    <NumberFormat
                      inputProps={{ maxLength: 3 }}
                      InputLabelProps={{
                        style: { pointerEvents: 'auto' },
                      }}
                      id="old"
                      label={(
                        <div>
                          Idade
                          {' '}
                          <HtmlTooltip
                            title={(
                              <>
                                Idade dos animais(em dias).
                              </>
                            )}
                            placement="top"
                            arrow
                          >
                            <HelpIcon color="primary" fontSize="inherit" />
                          </HtmlTooltip>

                        </div>
                      )}
                      variant="outlined"
                      name="old"
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={0}
                      value={formik.values.old}
                      onValueChange={(values) => {
                        formik.setValues({
                          ...formik.values,
                          old: values.floatValue,
                        });
                      }}
                      onBlur={formik.handleBlur}
                      customInput={TextField}
                      error={!!(formik.touched.old && formik.errors.old)}
                      helperText={
                        formik.touched.old
                        && formik.errors.old
                        && formik.errors.old
                      }
                    />
                  </FormGroup>
                </Grid>

                <Grid item xs={12} md={2}>
                  <FormGroup>
                    <NumberFormat
                      inputProps={{ maxLength: 11 }}
                      disabled={!!id}
                      InputLabelProps={{
                        style: { pointerEvents: 'auto' },
                      }}
                      id="size"
                      label="Quantidade de Animais"
                      variant="outlined"
                      name="size"
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={0}
                      value={formik.values.size}
                      onValueChange={(values) => {
                        formik.setValues({
                          ...formik.values,
                          size: values.floatValue,
                        });
                      }}
                      onBlur={formik.handleBlur}
                      customInput={TextField}
                      error={
                        !!(formik.touched.size && formik.errors.size)
                      }
                      helperText={
                        formik.touched.size
                        && formik.errors.size
                        && formik.errors.size
                      }
                    />
                  </FormGroup>
                </Grid>

                <Grid item xs={12} md={2}>
                  <FormGroup>
                    <NumberFormat
                      inputProps={{ maxLength: 14 }}
                      disabled={!!id}
                      InputLabelProps={{
                        style: { pointerEvents: 'auto' },
                        // shrink: true,
                      }}
                      id="price"
                      label="Preço da remessa"
                      variant="outlined"
                      name="price"
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={2}
                      // isNumericString={true}
                      prefix="R$"
                      value={formik.values.price}
                      onValueChange={(values) => {
                        formik.setValues({
                          ...formik.values,
                          price: values.floatValue,
                        });
                      }}
                      onBlur={formik.handleBlur}
                      customInput={TextField}
                      error={
                        !!(formik.touched.price && formik.errors.price)
                      }
                      helperText={
                        formik.touched.price
                        && formik.errors.price
                        && formik.errors.price
                      }
                    />
                  </FormGroup>
                </Grid>
              </Grid>
            </CardContent>
          </div>

          <GroupButton
            deleteRoute="/lots/"
            routeDelete="/lots"
            returnRoute="/lots"
            id={id}
            editable={false}
            messageDialogError
            disable={disable}
            message="A exclusão desse lote pode levar a exclusão de objetos que dependam dele. Tem certeza que deseja excluir?"
          />
        </form>
      </Card>
    </header>
  );
}

export default Lot;
